// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../../../../hooks/AuthContext";

// export const ProtectedAdminRoute = ({ children }) => {
//     const { token,loading } = useAuth();
//     if (loading) {
//     return null;
//     }
//     // If not authenticated, redirect to login
//     if (!token) {
//         return <Navigate to="/admin" />;
//     }

//     return children;
// };


import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuths from '../../../../hooks/UseAuths';

export const ProtectedAdminRoute = ({ children }) => {
    const {authState } = useAuths();
    if (authState === null) {
        return <div>Loading...</div>;
    }
    if (!authState?.isAuthenticated) {
        return <Navigate to="/admin" />;
    }

  return children;
};

